import { createSlice } from "@reduxjs/toolkit";

type SearchProps = {
  showSearchModal: boolean;
};

const initialState: SearchProps = {
  showSearchModal: false,
};

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setShowSearchModal: (state, action) => {
      state.showSearchModal = action.payload;
    },
  } });

export const { setShowSearchModal } = searchSlice.actions;
export default searchSlice.reducer;
